module.exports = __webpack_public_path__ + "static/jukka_nurminen-a10e2c182ec6c68a4ea135b1de487940.jpg";